export class BasicProgramInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(programId: string, programName: string | null);
    constructor(programId?: string, programName?: string | null) {
        if (programId !== undefined) {
            this.id = programId;
            this.name = programName;
        }
    }
}